export const SIGNUP_LOADING = 'SIGNUP_LOADING';
export const SIGNUP_SPORTS = 'SIGNUP_SPORTS';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';

export const INIT_STATE = {
	signupSuccess: false,
    sports: [],
}




// WEBPACK FOOTER //
// ./src/sign-up/constants/index.js